import type { FunctionComponent } from 'react';

import { Button, Loader } from '@kanda-libs/ks-design-library';

import type { FormattedTableJob } from 'components/job/JobTable/types';
import useDownloadCsv from 'components/job/JobsListPage/JobListPageActions/DownloadCsvButton/useDownloadCsv';

export interface DownloadCsvButtonProps {
  data: FormattedTableJob[];
}

const DownloadCsvButton: FunctionComponent<DownloadCsvButtonProps> = function ({
  data,
}) {
  const { onClick, isSubmitting } = useDownloadCsv(data);

  return (
    <>
      <Button.Text
        id="download-csv"
        label="Download CSV"
        onClick={() => {
          onClick();
        }}
        disabled={isSubmitting}
      />
      <Loader isLoading={isSubmitting} />
    </>
  );
};

export default DownloadCsvButton;
